export const LeadMap = {
  graphics: "Br. Mazhar",
  video: "Br. Imran",
  research: "Br. Tahir",
  marketing: "Br. Baba",
};
